import { render } from "./collection-selected-tags.vue?vue&type=template&id=0999db5e&scoped=true"
import script from "./collection-selected-tags.vue?vue&type=script&lang=js"
export * from "./collection-selected-tags.vue?vue&type=script&lang=js"

import "./collection-selected-tags.vue?vue&type=style&index=0&id=0999db5e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0999db5e"]])

export default __exports__